<template>
  <b-row>
    <b-col lg="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary"><strong>OPERATIONAL HISTORY - {{ fleet.name }}</strong></h4>
        </template>
        <template v-slot:body>
          <b-row>
            <b-col md="4">
              <b-form-group label="Type" label-for="type">
                <b-form-select  
                  plain
                  size="sm"
                  placeholder="Select type..."
                  v-model="params.type"
                >
                  <option value="">All</option>
                  <option value="progress">Progress</option>
                  <option value="finish">finish</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Date" label-for="date">
                <date-picker v-model="dateRange" type="date" range placeholder="Select date range" format="DD-MM-YYYY" class="w-100"></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Filter" label-for="filter">
                <b-button variant="primary" type="button" @click="() => fetchVoyageByTrips()"><i class="fa fa-filter"></i></b-button>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-row>
                <b-col md="12">
                  <div class="d-flex flex-column mb-2">
                      <div class="d-flex overflow-auto" v-if="list.length > 0">
                        <table class="table table-striped ">
                          <thead>
                            <tr>
                              <th rowspan="2" style="width:5px" class="text-truncate align-middle">NO</th>
                              <th rowspan="2" class="text-truncate align-middle">TYPE VOYAGE</th>                       
                              <th rowspan="2" class="text-truncate align-middle">TRIP INFO</th>                       
                              <th rowspan="2" class="text-truncate align-middle">STATUS</th>                       
                              <th rowspan="2" class="text-truncate align-middle">CARGO TYPE</th>                       
                              <th rowspan="2" class="text-truncate align-middle">CARGO LOADING</th>                       
                              <th rowspan="2" class="text-truncate align-middle">CARGO UNLOADING</th>  
                              <th rowspan="2" class=" text-truncate align-middle">START DATE</th>
                              <th rowspan="2" class=" text-truncate align-middle">END DATE</th>
                              <th colspan="18" class=" text-center">Port of Loading</th>
                              <th colspan="16" class=" text-center bg-warning">Port of Discharge</th>
                              <th rowspan="2" class=" text-center align-middle" style="width:5px; position: sticky; right: 0; z-index: 1">Action</th>
                            </tr>
                            
                            <tr>
                              <th class=" text-truncate">Agen POL</th>
                              <th class=" text-truncate">POL Grab Type</th>
                              <th class=" text-truncate">POL FC Name</th>
                              <th class=" text-truncate">POL MV Name</th>
                              <!-- <th class=" text-truncate">Arival Time POL</th> -->
                              <th class=" text-truncate">BL Date</th>
                              <th class=" text-truncate">NOR</th>
                              <th class=" text-truncate">NOA</th>
                              <th class=" text-truncate">Anchor Up</th>
                              <th class=" text-truncate">In Position / Berthing</th>
                              <th class=" text-truncate">Commenced</th>
                              <th class=" text-truncate">Completed</th>
                              <th class=" text-truncate">Draught Survey</th>
                              <th class=" text-truncate">Second Berthing</th>
                              <th class=" text-truncate">Cast Out</th>
                              <th class=" text-truncate">LHV</th>
                              <th class=" text-truncate">Document on Board</th>
                              <th class=" text-truncate">Departure to POD</th>
                              <th class=" text-truncate">Remarks</th>
                              
                              <th class=" text-truncate bg-warning">Agen POD</th>
                              <th class=" text-truncate bg-warning">POD Grab Type</th>
                              <th class=" text-truncate bg-warning">POD FC Name</th>
                              <th class=" text-truncate bg-warning">POD MV Name</th>
                              <th class=" text-truncate bg-warning">Arival Time POD</th>
                              <!-- <th class=" text-truncate">BL Date</th> -->
                              <th class=" text-truncate bg-warning">NOR</th>
                              <th class=" text-truncate bg-warning">NOA</th>
                              <th class=" text-truncate bg-warning">Anchor Up</th>
                              <th class=" text-truncate bg-warning">In Position / Berthing</th>
                              <th class=" text-truncate bg-warning">Commenced</th>
                              <th class=" text-truncate bg-warning">Completed</th>
                              <th class=" text-truncate bg-warning">Draught Survey</th>
                              <th class=" text-truncate bg-warning">Second Berthing</th>
                              <th class=" text-truncate bg-warning">Cast Out</th>
                              <!-- <th class=" text-truncate">LHV</th> -->
                              <!-- <th class=" text-truncate">Document on Board</th> -->
                              <th class=" text-truncate bg-warning">Departure to POL</th>
                              <th class=" text-truncate bg-warning">Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(state, index) in list" :key="index">
                              <td>{{index + 1}}</td>
                              <td class="text-truncate cursor-pointer" @click="openSlideDetailRealisasi('PREVIEW', state)">
                                <div class="d-flex flex-column">
                                  <span class="fs-5 mb-1" v-for="(v, v_index) in state?.vehicle" :key="`h-v-${v_index}`">
                                    <b-badge variant="success" v-if="v.id != Number($route.query.vehicleId)">{{ v.name }}</b-badge>
                                  </span>
                                  <b-badge variant="primary" v-if="state?.tripRecord?.voyageType">{{formatString(state?.tripRecord?.voyageType)}}</b-badge>
                                </div>
                              </td>
                              <td class="text-truncate">
                                <div class="d-flex flex-column"  v-if="state?.tripRecord?.id">
                                  <div class="d-flex align-items-center text-primary">
                                    <i class="fas fa-map-pin mr-2"></i>
                                    <strong class="mb-0 mr-1">{{ state?.tripRecord?.portLoading?.portName || state?.tripRecord?.portLoadingOther }}</strong>
                                  </div> 
                                  <div class="dashed-border"></div>
                                  <div class="d-flex align-items-center text-primary">
                                    <i class="fa fa-map-pin mr-2"></i>
                                    <strong class="mb-0 mr-1">{{ state?.tripRecord?.portDischarge?.portName || state?.tripRecord?.portDischargeOther }}</strong>
                                  </div>
                                </div>
                                <div v-else class="d-flex align-items-center text-danger">
                                  <i class="ri-close-circle-line mr-2"></i>
                                    No trip yet
                                </div>
                              </td>
                              <td>
                                <b-badge 
                                    :class="`text-xl text-uppercase mr-2`" :variant="`${state?.tripRecord?.status === 'Progress' ? 'warning' : 
                                    state?.tripRecord?.status === 'Finish' ? 'success' : 
                                    'primary'}`"
                                  >{{ state?.tripRecord?.status ?? '-' }}</b-badge>
                              </td>
                              <td>{{ state?.tripRecord?.cargoType ?? '-' }}</td>
                              <td>{{ Number(state?.tripRecord?.cargoLoading)?.toLocaleString() ?? '0' }}</td>
                              <td>{{ Number(state?.tripRecord?.cargoUnloading)?.toLocaleString() ?? '0' }}</td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.startDate ? moment(state?.tripRecord?.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.endDate ? moment(state?.tripRecord?.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">{{ state?.tripRecord.agentPol || '-' }}</td>
                              <td class="text-truncate text-capitalize">{{ formatString(state?.tripRecord.polGrabType || '') }}</td>
                              <td class="text-truncate text-capitalize">{{ state?.tripRecord.polFcName || '-' }}</td>
                              <td class="text-truncate text-capitalize">{{ state?.tripRecord.polMvName || '-' }}</td>
                              <!-- <td class="text-truncate">
                                {{ state?.tripRecord?.polArrivalTime ? moment(state?.tripRecord?.polArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> -->
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polBlDate ? moment(state?.tripRecord?.polBlDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polNor ? moment(state?.tripRecord?.polNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polNoa ? moment(state?.tripRecord?.polNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polAnchorUp ? moment(state?.tripRecord?.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polBerthing ? moment(state?.tripRecord?.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polCommenced ? moment(state?.tripRecord?.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polCompleted ? moment(state?.tripRecord?.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate text-center">{{Number(state?.tripRecord?.polDraughtSurvey)?.toLocaleString() ?? 0}}</td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polCastIn ? moment(state?.tripRecord?.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> 
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polCastOut ? moment(state?.tripRecord?.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> 
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polLhv ? moment(state?.tripRecord?.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polDocOnBoard ? moment(state?.tripRecord?.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.polDeparture ? moment(state?.tripRecord?.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-center">
                                <div style="width: 400px;" class="text-left">
                                  {{state?.tripRecord?.polRemark}}
                                </div>
                              </td>
                              <td class="text-truncate">{{ state?.tripRecord.agentPod || '-' }}</td>
                              <td class="text-truncate text-capitalize">{{ formatString(state?.tripRecord.podGrabType || '') }}</td>
                              <td class="text-truncate text-capitalize">{{ state?.tripRecord.podFcName || '-' }}</td>
                              <td class="text-truncate text-capitalize">{{ state?.tripRecord.podMvName || '-' }}</td>
                              <!-- <tremad class="text-truncate text-center">-</tremad> -->
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podArrivalTime ? moment(state?.tripRecord?.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <!-- <td class="text-truncate text-center">{{ state?.tripRecord?.podBlDate }}</td> -->
                              <td class="text-truncate text-center">
                                {{ state?.tripRecord?.podNor ? moment(state?.tripRecord?.podNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate text-center">
                                {{ state?.tripRecord?.podNoa ? moment(state?.tripRecord?.podNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podAnchorUp ? moment(state?.tripRecord?.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podBerthing ? moment(state?.tripRecord?.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podCommenced ? moment(state?.tripRecord?.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podCompleted ? moment(state?.tripRecord?.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                              <td>{{ Number(state?.tripRecord?.podDraughtSurvey)?.toLocaleString() ?? '0' }}</td>
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podCastIn ? moment(state?.tripRecord?.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> 
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podCastOut ? moment(state?.tripRecord?.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> 
                              <!-- <td class="text-truncate">
                                {{ state?.tripRecord?.podLhv ? moment(state?.tripRecord?.podLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> -->
                              <!-- <td class="text-truncate">
                                {{ state?.tripRecord?.podDocOnBoard ? moment(state?.tripRecord?.podDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td> -->
                              <td class="text-truncate">
                                {{ state?.tripRecord?.podDeparture ? moment(state?.tripRecord?.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                              </td>
                               <td class="text-center">
                                <div style="width: 380px;" class="text-left">
                                  {{state?.tripRecord?.podRemark}}
                                </div>
                              </td>
                              <td class="text-center align-middle " style="width:5px; position: sticky; right: 0; z-index: 1">
                                <b-dropdown
                                  size="sm"
                                  variant="dark"
                                  toggle-class="text-decoration-none"
                                  text="Actions"
                                  dropright
                                  no-caret
                                >
                                  <template v-slot:button-content>
                                    Actions
                                    <i class="fa fa-chevron-down ml-1"></i>
                                  </template>
                                  <b-dropdown-item
                                    variant="primary"
                                    @click="openSlideDetailRealisasi('PREVIEW', state)" 
                                  >
                                    <i class="fas fa-eye mr-2"></i> Detail
                                  </b-dropdown-item>
                                  <b-dropdown-item variant="primary" @click="openSlideEditOperational('EDIT', state)" v-if="state?.tripRecord?.status !== 'Finish'">
                                    <i class="fas fa-arrow-circle-down mr-2"></i> Edit
                                  </b-dropdown-item>
                                  <b-dropdown-divider v-if="!state?.activities && state?.tripRecord?.status !== 'Finish'" />
                                  <b-dropdown-item
                                    v-if="!state?.activities && state?.tripRecord?.status !== 'Finish'"
                                    href="#"
                                    variant="danger"
                                    @click="onDeleteTripRecord(state?.tripRecord.id)"
                                  ><i class="fa fa-trash mr-2"></i> Remove
                                  </b-dropdown-item>
                                </b-dropdown>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                </b-col>
                <b-col md="12" class="text-center">
                  <div class="mt-3" v-if="list.length > 0">
                    <b-pagination
                      v-model="meta.currentPage"
                      :total-rows="meta.total"
                      :per-page="meta.perPage"
                      first-number
                      @change="fetchVoyageByTrips"
                      align="center"
                    />
                  </div>
                  <strong class="text-center text-muted" v-else>Data not found.</strong>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </iq-card>
    </b-col>

     <!-- SLIDE - DETAIL REALISASI -->
     <b-col md="12">
        <b-sidebar
          v-model="slideDetailRealisasi"
          id="slideDetailRealisasi"
          :title="`Detail Real Shipment`"
          width="100%"
          backdrop-variant="dark"
          bg-variant="white"
          right
          backdrop
          shadow>
          <template #default="{hide}">
            <SlideDetailRealisasi 
              :id="id" 
              :closeSlideDetailRealisasi="closeSlideDetailRealisasi" 
            />
          </template>
        </b-sidebar>
      </b-col>
      <!-- SLIDE - DETAIL REALISASI END -->

      <!-- SLIDE - EDIT OPERATIONAL -->
      <b-col md="12">
        <b-sidebar
          v-model="slideEditOperational"
          id="slideEditOperational"
          :title="`Edit Operational`"
          width="80%"
          backdrop-variant="dark"
          bg-variant="white"
          right
          backdrop
          shadow>
          <template #default="{hide}">
            <SlideEditOperational 
              :id="id" 
              :closeSlideEditOperational="closeSlideEditOperational" 
            />
          </template>
        </b-sidebar>
      </b-col>
      <!-- SLIDE - EDIT OPERATIONAL END -->
  </b-row>
</template>

<script>
import { fleetsActions, voyagesActions } from '@src/Utils/helper'
import SlideDetailRealisasi from '../Busdev/Dashboard/SlideDetailRealisasi.vue'
import SlideEditOperational from './SlideEditOperational.vue'
import moment from 'moment'
import CustomNav from '@/src/components/global/CustomNav.vue';

export default {
  name: 'TabVoyageByTrip',
  props:{
    fleet:{
      type:Object,
      default:() => {}
    }
  },
  data () {
    return {
      slideDetailRealisasi: false,
      slideEditOperational: false,

      id: null,

      dateRange: [new Date(moment().startOf('year')), new Date(moment().endOf('year'))],
      page:1,
      params:{
        type:'', // 'progress', 'finish'
        startDate:null,
        endDate:null,
      },

      list:[],
      meta:{},
    }
  },
  components:{
    SlideDetailRealisasi,
    SlideEditOperational,
    CustomNav
  },
  computed: {
  },
  mounted () {
    this.fetchVoyageByTrips()
  },
  methods:{
    ...voyagesActions,
    formatString(str) {
      return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .toLowerCase()       // Convert to lowercase
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
    },
    closeSlideDetailRealisasi(){
      this.slideDetailRealisasi = false
      this.matrixData = null
      this.id = null
    },  
    openSlideDetailRealisasi(value, state){
      this.id = state?.tripRecord?.id
      this.slideDetailRealisasi = !this.slideDetailRealisasi;

      if(state?.tripRecord?.id) this.id = state?.tripRecord?.id
    }, 
    closeSlideEditOperational(){
      this.slideEditOperational = false
      this.matrixData = null
      this.id = null
    },  
    openSlideEditOperational(value, state){
      this.id = state?.tripRecord?.id
      this.slideEditOperational = !this.slideEditOperational;

      if(state?.tripRecord?.id) this.id = state?.tripRecord?.id
    },
    async fetchVoyageByTrips(page = 1) {
      let params = {
        page: page || 1,
        perPage: 25,
        vehicleId: Number(this.$route.query.vehicleId),
        ...this.params,
        startDate: this.dateRange?.[0] ? moment(this.dateRange?.[0]).format('DD-MM-YYYY') : null,
        endDate: this.dateRange?.[1] ? moment(this.dateRange?.[1]).format('DD-MM-YYYY') : null, 
      }

      // Iterate over each property in params
      for (const prop in params) {
        if (params.hasOwnProperty(prop)) {
          // Check conditions for each property and delete if necessary
          if ((params[prop] === '') || (params[prop] === null)) {
            delete params[prop];
          }
        }
      }

      const res = await this.getVoyageTrips(params)

      if (res.status == 'success') {
        this.list = res.data?.data

        this.meta.perPage = res.data.perPage
        this.meta.currentPage = res.data.currentPage
        this.meta.total = res.data.total
        this.meta.totalPage = res.data?.totalPage
      } else {
        this.list = []
      }
    },  

    async onDeleteTripRecord(id) {
      this.$swal({
        title: 'Delete Trip Record?',
        text: `Trip will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteTripRecordById({ id })
          if (res.status != 'success') {
            if (res.data.message != null) {
              this.$swal('Error', res.data.message, 'error')
            } else {
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
            }
          } else {
            this.fetchVoyageByTrips()
            this.$swal(
              `Trip deleted!`,
              `Trip successfully deleted`,
              'success'
            )
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.dashed-border {
  padding: 10px;
  border-left: 2px dashed black; /* Dashed left border */
  margin-left:3px
}
</style>